<template>
  <modal
    name="addadminmodal"
    width="70%"
    :minHeight="300"
    :minWidth="200"
    :maxWidth="800"
    :scrollable="true"
    :adaptive="true"
    :reset="true"
    height="auto"
    @before-open="beforeOpen"
  >
    <div class="modal--container">
      <div class="d-flex justify-content-between pt-3">
        <h4>{{ officeAdmin ? "Add Office Admin" : "Add Admin" }}</h4>
        <button type="button" @click="closeModal" class="close">
          <span aria-hidden="true"
            ><font-awesome-icon icon="times" size="1x"
          /></span>
        </button>
      </div>

      <div class="d-flex flex-column h-100">
        <div class="row mt-4">
          <div class="col-12 col-md-5 form-group multi-container">
            <span class="cus-label">Select Employee</span>
            <multiselect
              v-model="selected"
              label="name"
              track-by="name"
              placeholder="Select Employee"
              :maxHeight="150"
              :options="officeEmployees"
              @input="onChangeEmployee"
            ></multiselect>
          </div>
        </div>

        <table
          v-if="!officeAdmin && selected"
          class="table mt-4 table-bordered table-striped"
        >
          <thead>
            <tr>
              <th>Team</th>
              <th>Admin Access</th>
            </tr>
          </thead>

          <tbody v-if="officeTeams.length > 0">
            <tr v-for="team in officeTeams" :key="team.id">
              <td width="150">{{ team.attributes.name }}</td>
              <td>
                <input
                  :id="`checkbox-${team.id}`"
                  class="cus-checkbox"
                  type="checkbox"
                  v-model="team.checked"
                  :value="team.checked"
                  @click="checkTeam(!team.checked, team.id)"
                />
              </td>
            </tr>
          </tbody>
        </table>

        <div class="error my-2">
          <p>{{ this.error }}</p>
        </div>

        <div class="row justify-content-end align-items-end button-container">
          <button
            v-if="!officeAdmin"
            type="submit"
            class="save_btn hover-dark"
            v-on:click.stop="assignToTeams"
          >
            Save Changes
          </button>

          <button
            v-else
            type="submit"
            class="save_btn hover-dark"
            v-on:click.stop="addOfficeAdmin"
          >
            Save Changes
          </button>
        </div>
      </div>
    </div>
  </modal>
</template>
<script>
import { updateEmployee, assignEmployeeToTeams } from "../../../utils/api";
import { mapGetters, mapState } from "vuex";
import Multiselect from "vue-multiselect";
export default {
  name: "AddTeamModal",
  data() {
    return {
      teamName: "",
      selected: null,
      officeAdmin: false,
      officeTeams: [],
      error: ""
    };
  },
  components: { Multiselect },
  computed: {
    ...mapGetters(["getFirstEmployeeId"]),
    ...mapState(["listOfOfficeEmployeesAll", "officeAdmins"]),
    allOfficeAdmins() {
      return this.officeAdmins.map(admin => admin.id);
    },
    officeEmployees() {
      const allEmployees = this.listOfOfficeEmployeesAll.map(emp => {
        return {
          id: emp.id,
          name: `${emp?.attributes?.first_name} ${emp?.attributes?.last_name}`,
          first_name: emp?.attributes?.first_name,
          last_name: emp?.attributes?.last_name,
          email: emp?.attributes?.email,
          administered_teams: emp?.attributes?.administered_teams
        };
      });

      if (!this.officeAdmin) return allEmployees;
      else
        return allEmployees.filter(
          emp => !this.allOfficeAdmins.includes(emp.id)
        );
    }
  },
  methods: {
    beforeOpen(event) {
      this.selected = null;

      this.officeAdmin = JSON.parse(JSON.stringify(event?.params?.officeAdmin));

      if (!this.officeAdmin)
        this.officeTeams = JSON.parse(
          JSON.stringify(event?.params?.officeTeams)
        );

      this.officeTeams = this.officeTeams.map(team => {
        return {
          ...team,
          checked: false
        };
      });

      this.officeEmployees = this.officeEmployees.map(emp => {
        return {
          id: emp.id,
          name: `${emp?.attributes?.first_name} ${emp?.attributes?.last_name}`,
          first_name: emp?.attributes?.first_name,
          last_name: emp?.attributes?.last_name,
          email: emp?.attributes?.email,
          administered_teams: emp?.attributes?.administered_teams
        };
      });
    },
    onChangeEmployee() {
      this.officeTeams.forEach(team => {
        if (document.getElementById("checkbox-" + team.id)) {
          document.getElementById("checkbox-" + team.id).checked = false;
          document.getElementById("checkbox-" + team.id).disabled = false;
        }
      });
    },
    assignToTeams() {
      if (!this.selected) {
        this.$swal({
          title: "Select employee to make an admin for a team."
        });
        return;
      }

      let selectedTeams = this.officeTeams
        .filter(team => team.checked)
        .map(team => team.id);

      if (selectedTeams.length == 0) {
        this.$swal({
          title: "Select a team for which employee will be an admin."
        });
        return;
      }

      let loader = this.$loading.show();

      let params = {
        team_ids: selectedTeams
      };

      assignEmployeeToTeams(this.selected.id, params, this.getFirstEmployeeId)
        .then(response => {
          if (response.data) {
            loader.hide();
            this.closeModal();

            if (response?.data?.messages)
              this.$swal({
                title: response.data.messages,
                confirmButtonText: "OK"
              });

            this.$root.$emit("onGetOfficeTeams");
            this.$root.$emit("onGetOfficeEmployees");
            this.$root.$emit("onGetOfficeAdmins");
          }
        })
        .catch(err => {
          loader.hide();
        });
    },
    addOfficeAdmin() {
      if (!this.selected) {
        this.$swal({
          title: "Select an employee"
        });
        return;
      }

      const params = {
        id: this.selected.id,
        email: this.selected.email,
        first_name: this?.selected?.first_name,
        last_name: this.selected.last_name,
        location_employee: {
          role: "admin"
        }
      };

      let loader = this.$loading.show();

      updateEmployee(params, this.selected.id, this.getFirstEmployeeId)
        .then(res => {
          loader.hide();
          if (res.data && !res.data.employee)
            this.error =
              res.data.message instanceof Array
                ? res.data.message.join(",")
                : res.data.message;
          else {
            this.error = "";
            this.closeModal();
            this.$root.$emit("onGetOfficeAdmins");
            this.$root.$emit("onGetOfficeTeams");
            this.$root.$emit("onGetOfficeEmployees");
          }
        })
        .catch(() => {
          loader.hide();
        });
    },
    checkTeam(value, teamId) {
      let updatedList = this.officeTeams.map(team => {
        if (team.id == teamId) {
          return {
            ...team,
            checked: value
          };
        }
        return team;
      });
      this.officeTeams = updatedList;
    },
    closeModal() {
      this.$modal.hide("addadminmodal");
    }
  },
  watch: {
    selected: selected => {
      setTimeout(() => {
        selected?.administered_teams?.forEach(team => {
          if (document.getElementById("checkbox-" + team.id)) {
            document.getElementById("checkbox-" + team.id).checked = true;
            document.getElementById("checkbox-" + team.id).disabled = true;
          }
        });
      }, 300);
    }
  }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style lang="scss" scoped>
.button-container {
  margin-top: 200px;
}

.error {
  font-size: 16px;
  color: red;
  font-weight: 700;
}

h2 {
  font-size: 14px;
  font-weight: normal;
  color: #707070;
}

.modal--container {
  padding: 18px 30px;
  overflow-y: auto;
  height: 100%;
}

.close {
  color: #000000;
}

.cus-label {
  font-size: 14px;
  font-weight: normal;
  font-family: "Helvetica Neue";
  color: #000;
  margin-bottom: 6px;
}

.cus-checkbox {
  width: 20px;
  height: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/OfficeAdmin/Teams/AddAdminModal.vue